import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import { BSpinner, BToast } from 'bootstrap-vue'
import mensagens from '@/util/mensagens'
import util from '@/util'
import { mapState } from 'vuex'
import { filtrosMixin } from '@/modules/filtros/mixins'

export default {
  name: 'emitentes',
  components: {
    cabecalho,
    menuLateral,
    pagination,
    'default-table': defaultTable,
    'b-spinner': BSpinner,
    'b-toast': BToast
  },

  mixins: [filtrosMixin],

  data: () => {
    return {
      listaEmitentes: [],
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1
      },
      camposFiltroPesquisa: {
        razaoSocial: null,
        cnpj: null,
        inscricaoMunicipal: null
      },
      filtrosPesquisa: [],
      componenteOrdenacao: {
        campo: 'razao_social',
        sentido: 'asc'
      },
      fields: [
        { key: 'razao_social', sortable: true, label: 'Razão Social' },
        { key: 'cnpj', sortable: true, label: 'CNPJ' },
        { key: 'inscricao_municipal', sortable: true, label: 'Inscrição Municipal' }
      ]
    }
  },

  computed: {
    ...mapState('pagination', ['registrosPorPagina'])
  },

  mounted () {
    this.definirContexto('emitente')
    this.camposFiltroPesquisa = this.inicializarFiltrosPesquisa(this.camposFiltroPesquisa)
    this.componenteOrdenacao = this.inicializarComponenteOrdenacao(this.componenteOrdenacao)
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
    this.buscarRegistros()
  },

  methods: {

    limparFiltros () {
      this.limparFiltrosPesquisa()
      this.camposFiltroPesquisa = {
        razaoSocial: null,
        cnpj: null,
        inscricaoMunicipal: null
      }
    },

    async obterListaEmitentes () {
      try {
        this.flagsDeControle.carregandoDados.status = true
        this.flagsDeControle.carregandoDados.mensagem = mensagens.carregandoDadosEdicao

        const parametros = {
          page: this.componentePaginacao.pagina,
          registrosPorPagina: this.componentePaginacao.registrosPorPagina,
          filtros: this.filtrosPesquisa,
          ordenacao: this.componenteOrdenacao
        }

        const resposta = await this.axios.post('/emitente_nota_fiscal', parametros)

        this.listaEmitentes = resposta.data.retorno.dados
        this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
        this.componentePaginacao.ultimaPagina = resposta.data.retorno.paginacao.ultimaPagina
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }

      this.flagsDeControle.carregandoDados.status = false
      this.flagsDeControle.carregandoDados.mensagem = ''
    },

    buscarRegistros () {
      this.filtrosPesquisa = {
        razao_social: this.camposFiltroPesquisa.razaoSocial,
        cnpj: this.camposFiltroPesquisa.cnpj,
        inscricao_municipal: this.camposFiltroPesquisa.inscricaoMunicipal
      }

      this.componentePaginacao.pagina = 1
      this.obterListaEmitentes()
    },

    ordenarLista (context) {
      if (!util.valorVazio(context.sortBy)) {
        this.componenteOrdenacao.campo = context.sortBy
        this.componenteOrdenacao.sentido = context.sortDesc === true ? 'desc' : 'asc'
        this.salvarComponenteOrdenacao(this.componenteOrdenacao)
        this.obterListaEmitentes()
      }
    },

    incluirEmitente () {
      this.$router.push('/emitentes/cadastro')
    },

    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterListaEmitentes()
    },

    editarEmitente (id) {
      this.$router.push({ name: 'edicao-emitente', params: { id: id } })
    }
  }
}
